import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Dashboardreq } from '../req/dashboardreq.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardserviceService {

  Url: string = "https://atikaxgfk6.execute-api.ap-south-1.amazonaws.com/dev/superadmin/logout";
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization':localStorage.getItem("sessiontoken"),
      'x-api-key':localStorage.getItem("clientid")
     
    })
  };
  http: any;
  constructor(private httpClient : HttpClient) { }
  logoutUser(lgreq: Dashboardreq) {
    return this.httpClient.post(this.Url,lgreq,this.httpOptions);
  }
}
